import React from 'react';

export interface VoxelFormPanelContentProps {
  className?: string;
  disabled?: boolean;
}

export const VoxelFormPanelContent: React.FC<VoxelFormPanelContentProps> = ({
  children,
  className,
  disabled,
}) => {
  return (
    <div className={`p-6 flex flex-col gap-4 ${disabled ? 'opacity-60' : ''} ${className}`}>
      {children}
    </div>)
    ;
};

export default VoxelFormPanelContent;
